import { useState } from "react";
import { TAnswersType, TTableColumn } from "../../types";
import CustomTableMaterial from "../../shared/table/customTableMaterial";
import {
  ColoredStyleF,
  DisplayWithPicture,
  ReduceDisplayF,
  RowsPerPageEnum,
} from "../../displayColumnsConfig";
import { useAuthContext } from "../../context/authContext";
import { isAdmin, isDataOp, isTeacher } from "../../helpers/role";

function AnswersTable(props: { tableData: TAnswersType[] }) {
  const [page] = useState(0);
  const [rowsPerPage] = useState(RowsPerPageEnum.ALL);
  const { isAuth, authInfo } = useAuthContext();

  const answersColumns: TTableColumn[] = [
    {
      id: "order_task",
      label: "№ задачи",
      minWidth: 50,
      align: "right",
    },
    {
      id: "task_id",
      label: "Код задачи",
      minWidth: 60,
      align: "right",
      linkTo:
        isAdmin(authInfo.role) || isDataOp(authInfo.role)
          ? "/admin/task/edit/"
          : "/task/view/",
    },
    {
      id: "answer_count",
      label: "Дата ответа",
      minWidth: 50,
      align: "right",
    },
    {
      id: "answer",
      label: "Ответы",
      minWidth: 50,
      align: "right",
    },
    {
      id: "success",
      label: "Результаты",
      minWidth: 50,
      align: "center",
      stylef: ColoredStyleF,
    },
    {
      id: "question",
      label: "Текст задач",
      minWidth: 50,
      align: "left",
      expandable: true,
      stylef: () => {
        return { width: "50%" };
      },
      format: ReduceDisplayF,
      expandedFormat: DisplayWithPicture,
    },
  ];

  // set ids for keys in table
  let i = 1;
  props.tableData.forEach((r) => {
    if (!r.id) r["id"] = i++;
  });

  if (
    isAuth &&
    !isAdmin(authInfo.role) &&
    !isTeacher(authInfo.role) &&
    !isDataOp(authInfo.role)
  ) {
    // remove links for not admins
    answersColumns.forEach((e) => {
      if (e.id == "task_id") {
        delete e.linkTo;
      }
    });
  }

  return (
    <CustomTableMaterial<TAnswersType>
      list={props.tableData || []}
      page={page}
      columns={answersColumns}
      rowsPerPage={rowsPerPage}
      localPagination={true}
      // handleChangeRowsPerPage={handleChangeRowsPerPage}
      // handleChangePage={handleChangePage}
      groupBy="course_id"
      groupTitle={(row) =>
        `<a href="/course/${row["course_id"]}">Курс ${row["course_id"]} "${row["site_name"]}"</a>`
      }
    />
  );
}

export default AnswersTable;
